import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Configuration } from './models/configuration.model';

@Injectable()
export class ConfigService {
  private config: Configuration;

  constructor(private http: HttpClient) {}

  load(url: string) {
    return new Promise((resolve) => {
      this.http.get(url).subscribe((config: Configuration) => {
        this.config = config;
        resolve();
      })
    })
  }

  getConfiguration(): Configuration {
    return this.config;
}
}



// WEBPACK FOOTER //
// ./src/app/config.service.ts